import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../index';

type ToasterState = string;

const initialState: ToasterState = '';

const toasterSlice = createSlice({
  name: 'toaster',
  initialState,
  reducers: {
    toastMessage(_state, action: PayloadAction<string>) {
      // We use new String because we want the toast to show
      // even if it has exact same value as the previous toast
      return new String(action.payload).toString();
    },
  },
});

export const { toastMessage } = toasterSlice.actions;
export default toasterSlice.reducer;

export const selectCurrentToastMessage = (state: RootState): ToasterState =>
  state.toaster;
